import { YesNoScreen } from './yesnoScreen';
import { LoadingElement } from './loadingElement';
import { TNPSSurvey } from '../../utils/tnpsSurvey';
import { ScreenChangeNotice } from '../../customNotice/clientNotice/screenChangeNotice';
import { FeedbackReportingNotice } from '../../customNotice/botNotice/feedbackReportingNotice';
import { HandoverStatusNotice } from '../../customNotice/botNotice/handoverStatusNotice';
import { TrackingNotice } from '../../customNotice/botNotice/trackingNotice';
export class FeedbackScreen extends YesNoScreen {
    constructor(uic) {
        super("feedback", uic);
    }
    show(options) {
        this.uic.widgetHeaderController.enableEndChatOnCloseButton();
        this.elements['mainDiv'].show();
        if (options && options.loading) {
            this.loadingAnimation();
        }
        else {
            this.stopLoadingAnimation();
        }
    }
    hide() {
        this.elements['mainDiv'].hide();
    }
    bootstrapScreen(chatWindowElement) {
        super.bootstrapScreen(chatWindowElement);
        this.setupElements();
        this.elements['loader'] = new LoadingElement(this.elements['btnContainer'], "feedback");
    }
    resizeEvent() {
    }
    setupElements() {
        let i18n = this.uic.configuration.i18n;
        this.elements['text1'].html("Schade, dass du den Chat schon beenden möchtest.");
        this.elements['text2'].html("Konnte ich dir weiterhelfen?");
        this.elements['text3'].html("Mit deinem Feedback hilfst du mir, mich zu verbessern.");
        if (i18n) {
            if (i18n.feedbackScreenText1) {
                this.elements['text1'].html(i18n.feedbackScreenText1);
            }
            if (i18n.feedbackScreenText2) {
                this.elements['text2'].html(i18n.feedbackScreenText2);
            }
            if (i18n.feedbackScreenText3) {
                this.elements['text3'].html(i18n.feedbackScreenText3);
            }
        }
        this.elements['btnYes'].click(() => {
            let feedback = "1";
            this.loadingAnimation();
            this.uic.widget.sendCustomNotice(new ScreenChangeNotice("feedback", this.uic.widget.getWidgetApplicationId(), { loading: true }));
            this.uic.widget.sendCustomNotice(new FeedbackReportingNotice(feedback));
            try {
                let entryChannel = this.uic.widget.cachingService.surveyData.channelEntry;
                if (!entryChannel) {
                    entryChannel = this.uic.widget.cachingService.userData && this.uic.widget.cachingService.userData.value.channelEntry && this.uic.widget.cachingService.userData.value.channelEntry ? this.uic.widget.cachingService.userData.value.channelEntry : "N/A";
                }
                let config = {
                    apiUrl: this.uic.configuration.surveySettings.surveyEndpoint,
                    surveyId: this.uic.configuration.surveySettings.surveyIdFeedbackOffer,
                    useProbability: this.uic.configuration.surveySettings.useProbability,
                    customProbability: this.uic.configuration.surveySettings.customProbability,
                    usecase: this.uic.widget.cachingService.surveyData.usecase ? this.uic.widget.cachingService.surveyData.usecase : "N/A",
                    entrychannel: entryChannel,
                    feedback: feedback,
                    sessionId: this.uic.widget.cachingService.sessionId
                };
                this.uic.widget.createNewTNPSSurvey(config);
            }
            catch (e) {
                let event = TNPSSurvey.createCustomNoticeEvent(null, null, null, false, false, "Missing survey settings");
                this.uic.widget.sendCustomNotice(new ScreenChangeNotice("thankyou", this.uic.widget.getWidgetApplicationId()));
                this.uic.widget.sendCustomNotice(event);
            }
        });
        this.elements['btnNo'].click(() => {
            let feedback = "3";
            this.loadingAnimation();
            this.uic.widget.sendCustomNotice(new ScreenChangeNotice("feedback", this.uic.widget.getWidgetApplicationId(), { loading: true }));
            this.uic.widget.sendCustomNotice(new FeedbackReportingNotice(feedback));
            this.uic.widget.getStateMachine().handoverAvailable = false;
            this.uic.widget.getStateMachine().handoverStatusRequestFinished = false;
            this.uic.widget.sendCustomNotice(new HandoverStatusNotice());
            this.uic.widget.bridge.Helpers.wait(() => {
                return this.uic.widget.getStateMachine().handoverStatusRequestFinished;
            })
                .then(() => {
                if (this.uic.widget.getStateMachine().handoverAvailable) {
                    this.uic.showScreen("handoverOffer");
                    this.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Feedback_ho_screen_view", "Feedback_ho_screen_view"));
                    this.uic.widget.sendCustomNotice(new ScreenChangeNotice("handoverOffer", this.uic.widget.getWidgetApplicationId()));
                }
                else {
                    this.uic.showScreen("thankyou");
                    this.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Feedback_screen_no_agent", "Feedback_screen_no_agent"));
                    this.uic.widget.sendCustomNotice(new ScreenChangeNotice("thankyou", this.uic.widget.getWidgetApplicationId()));
                }
            }).catch(() => {
                let trackingNotice = new TrackingNotice("chat", "error", "no handover status event retrieved");
                this.uic.widget.sendCustomNotice(trackingNotice);
                this.uic.showScreen("thankyou");
                this.uic.widget.sendCustomNotice(new ScreenChangeNotice("thankyou", this.uic.widget.getWidgetApplicationId()));
            });
        });
        this.elements['close'].click(() => {
            this.uic.widget.sendCustomNotice(new TrackingNotice("chat", "Feedback_screen_close", "Feedback_screen_close"));
        });
    }
    stopLoadingAnimation() {
        this.elements['loader'].hide();
        this.elements['btnYes'].show();
        this.elements['btnNo'].show();
    }
    loadingAnimation() {
        this.elements['loader'].show();
        this.elements['btnYes'].hide();
        this.elements['btnNo'].hide();
    }
}
